import { createTheme } from "@mui/material";

export const MUI_Theme = createTheme({
  /*typography: {
    fontFamily: '"BERNARD MT CONDENSED", sans-serif',
  },*/  // TODO Get confirmation on this
  palette: {
    primary: {
      main: "#E3BD90",
    },
    secondary: {
      main: "#4A2811",
    },
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#4A2811",
        },
      },
    },
  },
});
